module.exports = __webpack_public_path__ + "img/right-chevron.f0d2c2d8.svg";